import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ItemFormContainer from '../../../booking/containers/car_parking/ItemFormContainer';



class AddCarParkingContainer extends Component {
    static propTypes = {
        data: PropTypes.object
    };

    render() {
        return <ItemFormContainer />;
    }
}

export default connect()(AddCarParkingContainer);
